module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/KlQQrz/media/FC-9781528969550.jpg?1697494221093",
      "alt": "This image is the cover for the book Himalayan Tsunami"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Himalayan Tsunami\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In June of 2013, darkened skies over northern India released torrential rains from multiple cloudbursts, leaving behind an incomprehensible trail of destruction. American cardiologist, Dr. Seshadri, had just arrived in the Indian state of Uttarakhand for a spiritual retreat when the colossal storms hit. Stranded on the isolated grounds of an ashram with his fellow retreatants, he is forced to address the mental and physical wreckage of this natural disaster. “An arresting tsunami account told with great intelligence.” – Kirkus Reviews “Gripping… amazingly well-written.” – Om Swami, best-selling author of If Truth be Told: A Monk’s Memoir")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Niranjan Seshadri\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Niranjan Seshadri and Erika Seshadri live on an animal rescue ranch in Sarasota, Florida, with their three children. In their fleeting moments of spare time, they enjoy writing poetry together. Niranjan’s penchant for adventure and Erika’s love of writing provided the perfect storm in which to create their debut work, Himalayan Tsunami.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0